import { Dropdown, DropdownWidth, Option, typographyRem } from '@by-miles/bymiles-styles'

import { ToolTip } from '../../../../../ToolTip'
import { handleDropdownState } from '../../../../utils/handleDropdownState'
import { handlePrefilledDropdown } from '../../../../utils/handlePrefilledDropdown'
const { h5: H5 } = typographyRem

interface OwnershipProps {
  showErrorBanner: boolean
  notAnsweredMessage: string
  dropDownOptions: Option[]
  legalOwner: string
  handleLegalOwner: (value: string) => void
  legalOwnerValid: boolean
  isMobile: boolean
  keeper: string
  handleKeeper: (value: string) => void
  keeperValid: boolean
}

export const Ownership = ({
  showErrorBanner,
  notAnsweredMessage,
  dropDownOptions,
  handleLegalOwner,
  legalOwner,
  legalOwnerValid,
  isMobile,
  keeper,
  handleKeeper,
  keeperValid,
}: OwnershipProps) => {
  return (
    <>
      <div className="question-container" id="legalOwner">
        <div className="question-text-container">
          <H5>Who is (or will be) the legal owner of this car?</H5>
        </div>
        <div className="input-info-container">
          <Dropdown
            options={dropDownOptions}
            placeholder="Select"
            handleDropdownChange={option => handleLegalOwner(option.value)}
            width={DropdownWidth.Large}
            states={handleDropdownState(legalOwnerValid, showErrorBanner && !legalOwnerValid ? notAnsweredMessage : '')}
            dataCy="car-owner-dropdown-list"
            isMobile={isMobile}
            preFilled={handlePrefilledDropdown(dropDownOptions, legalOwner)}
            className="dropdown-large-with-icon dropdown-above"
            errorMessage={showErrorBanner && !legalOwnerValid ? notAnsweredMessage : undefined}
            ariaLiveOnFocus
          />
          <ToolTip
            text="The legal owner is the person who purchased the car or was given it as a gift."
            className="tool-tip tip-top-small"
            dataCy="car-owner-info-button"
          />
        </div>
      </div>
      <div className="question-container" id="keeper">
        <div className="question-text-container">
          <H5>Who is (or will be) the registered keeper of this car?</H5>
        </div>
        <div className="input-info-container">
          <Dropdown
            options={dropDownOptions}
            placeholder="Select"
            handleDropdownChange={option => handleKeeper(option.value)}
            states={handleDropdownState(keeperValid, showErrorBanner && !keeperValid ? notAnsweredMessage : '')}
            errorMessage={showErrorBanner && !keeperValid ? notAnsweredMessage : undefined}
            isMobile={isMobile}
            width={DropdownWidth.Large}
            dataCy="car-keeper-dropdown-list"
            preFilled={handlePrefilledDropdown(dropDownOptions, keeper)}
            className="dropdown-large-with-icon dropdown"
            ariaLiveOnFocus
          />
          <ToolTip
            text="The registered keeper is the person whose name appears in the car’s log book (V5 registration document). The owner of the car and the registered keeper can be different people."
            className="tool-tip tip-top-small"
            dataCy="car-keeper-info-button"
          />
        </div>
      </div>
    </>
  )
}
